import { Component } from '@angular/core';
import { WHATSAPP } from '../../../constants/whatsapp';

@Component({
  selector: 'allas-prefieres-que-lo-hagamos-nosotros',
  imports: [],
  template: `
    <main class="flex flex-col gap-2 mt-12">
      <!-- Desktop Version -->
      <section
        class="hidden xl:flex flex-col xl:flex-row my-6 xl:my-12 max-w-6xl mx-auto w-full"
      >
        <div
          class="p-6 xl:p-6 flex flex-col items-center justify-center flex-auto xl:h-[450px]"
        >
          <article class="flex flex-col gap-2">
            <h2 class="text-2xl xl:text-5xl font-bold fs-condensed">
              ¿Prefieres que lo <br />
              hagamos nosotros?
            </h2>
            <p>
              Evita complicaciones y deja que nuestros expertos instalen <br />
              tus limpiaparabrisas. Servicio rápido y profesional.
            </p>
          </article>
        </div>
        <div class="h-auto xl:h-[450px]">
          <img
            src="/images/services/cambio-limpiaparabrisas/prefieres-que-lo-hagamos-nosotros.webp"
            alt="prefieres que lo hagamos nosotros"
            class="h-full w-auto object-cover"
          />
        </div>
      </section>

      <!-- Mobile Version -->
      <section class="xl:hidden flex flex-col my-6 max-w-6xl mx-auto w-full">
        <div class="p-6 flex flex-col items-center justify-center">
          <article class="flex flex-col gap-2 text-center">
            <h2 class="text-4xl font-bold fs-condensed">
              ¿Prefieres que lo hagamos nosotros?
            </h2>
            <p class="text-sm">
              Evita complicaciones y deja que nuestros expertos instalen tus
              limpiaparabrisas. Servicio rápido y profesional.
            </p>
          </article>
        </div>
        <div class="h-auto">
          <img
            src="/images/services/cambio-limpiaparabrisas/prefieres-que-lo-hagamos-nosotros.webp"
            alt="prefieres que lo hagamos nosotros"
            class="h-full w-full object-cover"
          />
        </div>
      </section>

      <!-- Desktop Buttons -->
      <section
        class="hidden xl:flex bg-gray-100 flex-col xl:flex-row items-center justify-center gap-2 p-4 py-8 mb-6"
      >
        <a
          href="/encuentra-tu-tienda"
          class="bg-black text-white text-xs xl:text-sm px-4 py-1 xl:py-2 rounded-md hover:scale-105 transition-transform duration-150"
        >
          SOLICITAR INSTALACIÓN
        </a>
        <a
          [href]="whatsapp.url('Hola, necesito cotizar una instalación de limpiaparabrisas. ¿Podrían ayudarme?')"
          class="border border-black text-black px-4 py-1 xl:py-2 rounded-md text-xs xl:text-sm hover:scale-105 transition-transform duration-150"
        >
          COTIZACIÓN GRATUITA
        </a>
      </section>

      <!-- Mobile Buttons -->
      <section
        class="xl:hidden bg-gray-100 flex flex-row items-center justify-center gap-3 p-4 py-8 mb-6"
      >
        <a
          href="/encuentra-tu-tienda"
          class="bg-black text-white border border-black text-[12px] px-3 py-2 rounded-md hover:scale-105 transition-transform duration-150 flex-1 text-center"
        >
          SOLICITAR INSTALACIÓN
        </a>
        <a
          [href]="whatsapp.url('Hola, necesito cotizar una instalación de limpiaparabrisas. ¿Podrían ayudarme?')"
          class="border border-black text-[12px] text-black px-3 py-2 rounded-md hover:scale-105 transition-transform duration-150 flex-1 text-center"
        >
          COTIZACIÓN GRATUITA
        </a>
      </section>
    </main>
  `,
})
export class PrefieresQueLoHagamosNosotros {
  readonly whatsapp = WHATSAPP;
}
